import { create } from 'zustand';

type NavigationGuardState = {
  isDirty: boolean;
  setIsDirty: (dirty: boolean) => void;
  reset: () => void;
};

export const useNavigationGuardStorage = create<NavigationGuardState>((set) => ({
  isDirty: false,
  setIsDirty: (dirty: boolean) => set({ isDirty: dirty }),
  reset: () => set({ isDirty: false }),
}));

export const useNavigationGuardStore = () => useNavigationGuardStorage((state) => state.isDirty);
export const useSetNavigationGuardStore = () =>
  useNavigationGuardStorage((state) => state.setIsDirty);
export const useResetNavigationGuard = () => useNavigationGuardStorage((state) => state.reset);
